<template>
  <div class="row">
    <div class="col-20 upper-std-wrapper-title">
      {{ $t('view-CampaignsCpcDetails.title') }}
    </div>
    <div class="col-20 std-wrapper mt-0 p-3 px-4 pt-4">
      <div class="row">
        <div class="col-20 col-md-10">
          <data-display
            :title="$t('view-CampaignsCpcDetails.label.name')"
            class="mb-4 d-block"
          >
            {{ campaign.name }}
          </data-display>
          <data-display
            :title="$t('view-CampaignsCpcDetails.label.description')"
            :textarea="true"
            class="mb-4 d-block"
          >
            {{ campaign.description }}
          </data-display>
          <data-display
            :title="$t('view-CampaignsCpcDetails.label.link')"
            class="mb-4 d-block"
          >
            {{ campaign.link }}
          </data-display>
        </div>
        <div class="col-20 col-md-8 offset-md-2">
          <data-display
            :title="$t('view-CampaignsCpcDetails.label.value_per_click')"
            class="mb-4 d-block"
          >
            {{ campaign.value_per_click }} {{ $currencySymbol(campaign.currency) }}
          </data-display>
          <data-display
            :title="$t('view-CampaignsCpcDetails.label.author')"
            class="mb-4 d-block"
          >
            <div class="text-center">
              <div
                v-lazy-container="{ selector: 'img' }"
                class="avatar mt-1 mb-2"
              >
                <img :data-src="$store.getters['user/getAvatar'](advertiser.user)">
              </div>
              <strong>{{ advertiser.user.name }}</strong>
            </div>
          </data-display>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleDataDisplay from '../../../components/SimpleDataDisplay.vue'

export default {
  components: {
    'data-display': SimpleDataDisplay
  },
  props: {
    campaign: {
      type: Object,
      default: () => { return {} }
    },
    advertiser: {
      type: Object,
      default: () => { return {} }
    }
  }
}
</script>

<style lang="scss" scoped>
  .avatar img {
    border-radius: 100%;
    width: 200px;
    height: 200px;
  }
</style>
